import {SKZ_MUTATION_KEYS, SkillzMutation} from '@api/ReactQueryClient';
import CurrentUserStore from 'CurrentUserStore';
import NetClient from 'NetClient';
import type SKZPersonalInfo from 'SKZPersonalInfo';
import {ErrorObjectType, ErrorResponse} from 'NetClientTypes';
import {NativeModules} from 'react-native';
import {isArray} from 'lodash';
import {EmailData} from 'SKZPersonalInfo';

const SKZAPIManager = NativeModules.SKZAPIManager;

type ExcludeSecondaryEmails<T> = Omit<T, 'secondary_emails'>;
interface ISKZPersonalInfoForUpdate extends ExcludeSecondaryEmails<SKZPersonalInfo> {
  readonly secondary_emails: string[];
}

type UpdateUserPersonalInfoMutationVariables = {
  data: Partial<ISKZPersonalInfoForUpdate>;
  errorHandling?: typeof SKZAPIManager.OnError;
};
type UpdateUserPersonalInfoMutationError = ErrorObjectType & {
  name: 'EMAIL_ALREADY_EXISTS';
};
export const updateUserPersonalInfoMutation = new SkillzMutation<
  ISKZPersonalInfoForUpdate,
  UpdateUserPersonalInfoMutationVariables,
  UpdateUserPersonalInfoMutationError
>(SKZ_MUTATION_KEYS.USER_PERSONAL_INFO, async ({data: newUserPersonalInfo, errorHandling}) => {
  const currentUserId = await CurrentUserStore.getCurrentUserId();
  const currentData = await CurrentUserStore.getUserPersonalInfo();

  const secondary_emails = currentData?.secondary_emails.map((item: EmailData) => item.email) ?? [];
  const newData = {...currentData, secondary_emails, ...newUserPersonalInfo};

  return new Promise((resolve, reject) => {
    NetClient.patchURL(
      `users/${currentUserId}/personal`,
      newData,
      errorHandling ?? SKZAPIManager.OnError.failSilently,
      (error: ErrorResponse, payload: unknown) => {
        if (error) {
          reject(isArray(error.responseObject) ? error.responseObject[0] : error);
        } else if (payload) {
          resolve(payload as ISKZPersonalInfoForUpdate);
        }
      }
    );
  });
});
